// extracted by mini-css-extract-plugin
export default {"icon":"SVGIcon_icon__ymatf","sizeAuto":"SVGIcon_sizeAuto__RlMHP"};